import React from "react";
import { View, Image, StyleSheet } from "@react-pdf/renderer";

import "./index.scss"

export function HeaderBackgroundPdf({ background }) {

    return (
        <View style={styles.headerBackgroundContainer}>
            {background  ?
                <Image style={styles.container} src={background} />
                :
                <View style={styles.container} />
            }
        </View>

    )
}

export function HeaderBackground({ background }) {

    return (
        <div className="headerBackgroundContainer">
            {background ?
             <img className="headerBackgroundContainer" src={background} alt='img'/>
                 :
                 <div className="headerBackgroundContainer">
                 </div>
            }

        </div>
    )

}

const styles = StyleSheet.create({
    headerBackgroundContainer: {
        width: '100%',
        height: '100%'
    },
})